import { dateToDefaultFormat } from "../utilities/parseHelper"
import { UserDocumentData } from "./userDocumentData";

/**
* Информация по пользовательской подписке.
*/
export class UserSubscriptionData {
  /**
  * Идентификатор подписки.
  */
  public Id: number = 0;

  /**
  * Документ пользователя, который используется для подписки.
  */
  public Document: UserDocumentData = new UserDocumentData();

  /**
  * Дата и время последнего поиска начислений по подписке.
  */
  public LastSearchDate: string | null = null;

  /**
  * Активность подписки.
  */
  public Active: boolean = false;

  /**
  * Включена ли автооплата для этой подписки.
  */
  public AutoExecute: boolean = false;

  /**
  * Счет, с которого происходит автооплата.
  */
  public Contract: string = ""

  /**
  * Заголовок
  */
  public Caption: string = ""

  /**
  * Описание
  */
  public Description: string = ""

  // get NotificationIconSource(): string {
  //   if (!this.Active)
  //     return "notification_disable.png";
  //   else if (store.getters.isVip)
  //     return "notification_vip.png";
  //   else return "notification.png";
  // }

  // get ActiveIconSource(): string {
  //   if (!this.AutoExecute)
  //     return "active_disable.png";
  //   else if (store.getters.isVip)
  //     return "active_vip.png";
  //   else return "active.png";
  // }

  /**
  * Конструктор с загрузкой данных из JObject.
  */
  public constructor(src: any = null) {
    if (src == null)
      return;

    this.Id = src.Id ?? 0;
    this.LastSearchDate = dateToDefaultFormat(src.LastSearchDate) ?? null;
    this.Active = src.Active ?? false;
    this.AutoExecute = src.AutoExecute ?? false;
    this.Contract = src.Contract ?? "";
    this.Caption = src.Caption ?? "";
    this.Description = src.Description ?? "";
    this.Document = new UserDocumentData(src.Document);
  }

  public copy(data: UserSubscriptionData) {
    this.Id = data.Id;
    this.LastSearchDate = data.LastSearchDate;
    this.Active = data.Active;
    this.AutoExecute = data.AutoExecute;
    this.Contract = data.Contract;
    if(data.Document)
      this.Document.copy(data.Document);
  }
}

